import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import 'babel-polyfill'

import RequiredCom from './config'
import 'iview/dist/styles/iview.css'

import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

//全局组件
import { Message } from 'iview'
Vue.prototype.$Message = Message

// 引入省市选择器
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker)

Vue.use(RequiredCom)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
